import { Button } from "@components/buttons/button";
import { Close } from "@components/buttons/close";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { ReactNode, useEffect, useState } from "react";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  header: string;
  title: string;
  html: ReactNode;
}

export function ModalInfoHtml({
  isOpen,
  onClose,
  header,
  title,
  html,
}: IProps) {
  const [animate, setAnimate] = useState(false);
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  function handleClose() {
    setAnimate(false);
    setTimeout(() => onClose(), 300);
  }

  function handleEscape(evt: KeyboardEvent) {
    if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
      handleClose();
    }
  }

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setAnimate(true), 10);
      document.addEventListener("keydown", handleEscape);

      return () => {
        document.removeEventListener("keydown", handleEscape);
      };
    } else {
      setAnimate(false);
    }
  }, [isOpen]);

  return (
    <>
      <div
        className={`modal fade ${animate && isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
        aria-labelledby="staticBackdropLabel"
        aria-hidden={!isOpen}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold" id="contentModallLabel">
                {header}
              </h5>
              <Close onPress={handleClose} />
            </div>
            <div className="modal-body">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div className="row">
                  <div className="col-md-12 col-12">
                    <h5 className="modal-title">{title}</h5>
                  </div>
                  <div className="col-md-12 mb-2 col-12">{html}</div>
                  <div className="col-md-12 mb-2 col-12 text-end">
                    <Button
                      onClick={handleClose}
                      children="Entendido"
                      className="btn btn-primary py-2 px-5"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal-backdrop fade ${animate && isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
      ></div>
    </>
  );
}
